export const BOOLEAN_OPTIONS_DATA = [
  { value: true, text: "Yes" },
  { value: false, text: "No" },
];
